import { ChevronRight } from 'lucide-react';

import { CATEGORY_DISPLAY_NAMES, type SkillCommand } from '../../../../lib/skill-constants';
import {
  SkillListExampleUsage,
  SkillListExpandedHint,
  SkillListExpandedSection,
  SkillListExpandedSubLabel,
} from '../skill-list-item';

export function WtwSkillRow({
  command,
  isExpanded,
  onToggleExpanded,
}: {
  command: SkillCommand;
  isExpanded: boolean;
  onToggleExpanded: () => void;
}) {
  const title = command.title ?? command.handle;
  const categoryLabel = CATEGORY_DISPLAY_NAMES[command.category] || command.category;

  return (
    <div className="border-b border-[#DEE2E7] bg-white last:border-b-0">
      <button
        type="button"
        className="flex w-full items-start justify-between gap-4 p-4 text-left transition-colors hover:bg-[#FAFBFC]"
        onClick={onToggleExpanded}
        aria-expanded={isExpanded}
        aria-label={isExpanded ? `Collapse details for ${title}` : `Open details for ${title}`}
      >
        <span className="min-w-0">
          <span className="block truncate font-['Open_Sans',sans-serif] text-[14px] leading-5 font-semibold text-[#262D46]">
            /{command.handle}
          </span>
          <span className="mt-1 block font-['Open_Sans',sans-serif] text-[14px] leading-5 text-[#546A83]">
            {command.description}
          </span>
          <span className="mt-2 flex flex-wrap items-center gap-3 font-['Open_Sans',sans-serif] text-[12px] leading-4 text-[#546A83]">
            <span>{categoryLabel}</span>
          </span>
        </span>
        <ChevronRight
          aria-hidden="true"
          className={`mt-1 h-4 w-4 shrink-0 text-[#98A6B5] transition-transform ${isExpanded ? 'rotate-90' : ''}`}
        />
      </button>

      {isExpanded ? (
        <div className="border-t border-[#DEE2E7] bg-[#FAFBFC] px-4 py-3">
          <SkillListExpandedSection label="What it does">
            <div className="flex min-w-0 flex-col gap-1">
              <SkillListExpandedSubLabel>Use `/{command.handle}` to load this skill</SkillListExpandedSubLabel>
              <div className="mt-2">
                <SkillListExpandedHint>{command.overview}</SkillListExpandedHint>
              </div>
            </div>
          </SkillListExpandedSection>

          {command.exampleUsage ? (
            <SkillListExpandedSection label="Example usage">
              <SkillListExampleUsage handle={command.handle}>{command.exampleUsage}</SkillListExampleUsage>
            </SkillListExpandedSection>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
